<template>
  <div>
    <v-card
      flat
      :loading="loading"
      class="tab-details"
    >
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-card-text>
        <div class="mx-12 text-h6 font-weight-black mt-3 text-c-green">
          {{ local.caseFile.tabHeaders.sessions }}
        </div>
        <v-row class="mx-12">
          <template v-for="(item, index) in sessions">
            <v-col
              :key="index"
              cols="4"
            >
              <session-card
                :session="item"
                :case-object-key="caseObjectKey"
                :is-pega="isPega"
                :court-id="courtId"
                @session-card-click="openSessionInfo(item)"
                @attest-session="openSessionInfo(item)"
              >
              </session-card>
            </v-col>
          </template>
          <v-col cols="12">
            <naj-no-data
              :has-data="sessions && sessions.length > 0"
              :loading="loading"
            ></naj-no-data>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <pdf-dabt-attestation-modal
      :sessions-items="sessions"
      :selected-session-index-prop="selectedSessionIndex"
      :modal-visibility="showSessionInfoModal"
      @modalClose="closeSessionInfo"
      @reloadSessions="reloadSessions"
    ></pdf-dabt-attestation-modal>
    <degree-color-palette></degree-color-palette>
    <qaim-evaluation
      v-if="showEvaluationModal"
      :request-evaluations-code="qaimConfig.requestEvaluationsCodes.sessions"
      :ref-num="sessionObjectKey"
      :is-lawsuit-request="true"
      @updateShowEvaluationModal="updateShowEvaluationModal()"
    >
    </qaim-evaluation>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('CasesModule');
import SessionCard from '../../../../global/components/cards/session-card.vue';
import { sessionTypes, sessionStatus, attestationSigningMethod } from '@/helpers/enum';
import DegreeColorPalette from '../degree-color-palette';
import pdfDabtAttestationModal from '../../../pdf-dabt-attestation-modal';
import qaimEvaluation from '@/modules/lawsuit/components/qaim-evaluations';
const { mapActions: mapGlobalActions, mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');

export default {
  name: 'CaseSessionsTab',
  components: {
    SessionCard,
    DegreeColorPalette,
    pdfDabtAttestationModal,
    qaimEvaluation,
  },
  props: {
    caseObjectKey: {
      type: String,
      required: true,
    },
    isPega: {
      type: String,
      required: true,
    },
    courtId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      sessions: [],
      loading: false,
      sessionTypes,
      sessionStatus,
      selectedSession: null,
      showSessionInfoModal: false,
      selectedSessionIndex: 0,
      showEvaluationModal: false,
      sessionObjectKey: '',
    };
  },
  computed: { ...mapGlobalState(['userInfo', 'qaimConfig']) },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapGlobalActions(['getUserInfo']),
    ...mapActions([
      'getCaseSessions',
      'attestDabtByParty',
    ]),
    loadData() {
      const params = {
        objectKey: this.caseObjectKey,
        isPega: this.isPega,
      };
      this.loading = true;
      this.getCaseSessions(params)
        .then((res) => {
          this.sessions = res.data;
        })
        .finally(() => (this.loading = false));
    },
    reloadSessions(value, isVideoConference) {
      this.sessions = [];
      this.sessionObjectKey = value;
      if (isVideoConference) this.showEvaluationModal = true;
      this.loadData();
    },
    updateShowEvaluationModal() {
      this.showEvaluationModal = false;
    },
    openSessionInfo(session) {
      this.showSessionInfoModal = true;
      this.selectedSession = session;
      this.selectedSessionIndex = this.sessions.findIndex(a => a.id == session.id);
    },
    closeSessionInfo() {
      this.showSessionInfoModal = false;
      this.selectedSessionIndex = 0;
    },
  },
};

</script>

<style lang="scss" scoped>
.btn-style {
  float: left;
}
.button-style {
  color: #af0707;
  margin-left: 35px;
  margin-top: 5px;
  font-weight: 700;
  float: left;
}
::v-deep .v-input--radio-group {
  .options-list {
    display: inline-grid !important;
    background: none;
  }

  .radio-button-option {
    background: none !important;
    border: 0px !important;
  }
}

::v-deep .v-input.v-input--selection-controls {
  .v-label {
    font-size: 18px;
  }
}
</style>